module.exports = __webpack_public_path__ + "static/img/red.e6b1752.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4/red.png
// module id = cwb/
// module chunks = 0